import React from 'react';
import * as styles from './productCardSection.module.scss';
import { usePageContext } from '../context/pageContext';
import {
  ExpertisePagesQuery,
  SanityCountrySettings,
  SanityProductCardSection,
} from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { CTA } from '../html-tag/Cta';
import { graphql, useStaticQuery } from 'gatsby';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';
import { constructSlug } from '../../utils/constructSlug';
import { SanityPageProduct } from '../../../graphql-types';
import { useGeoContext } from '../context/useGeoContext';
import { isCountryAllowed } from '../../utils/isCountryAllowed';

interface Props {
  section: SanityProductCardSection;
}

export const ProductCardSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const { country } = useGeoContext();
  const pages = useStaticQuery<ExpertisePagesQuery>(PRODUCTPAGESLUG);

  return (
    <div className={styles.wrapper}>
      {section?.activeTitle && (
        <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      )}
      {section?.activeButton && (
        <div className={styles.titleButton}>
          <CTA
            label={findTranslation(section?._rawButtonSection, lang, defaultLang)}
            dataType={'orange'}
            to={'/contact'}
          />
        </div>
      )}
      <div className={styles.container}>
        {section?.productCardsList
          ?.filter((productCard) =>
            isCountryAllowed(
              country,
              productCard?.ctaProductCard?.countrySettings as SanityCountrySettings,
            ),
          )
          .map((productCard, index) => {
            return (
              <div
                className={styles.productCard}
                key={`productCard-${index}`}
              >
                <div className={styles.image}>
                  <GatsbyImage
                    alt={productCard?.imgBgProductCard?.alt ?? ''}
                    image={productCard?.imgBgProductCard?.img?.asset?.gatsbyImageData}
                  />
                  <div className={styles.overlay} />
                  <div className={styles.content}>
                    <h2>{findTranslation(productCard?._rawTitleProductCard, lang, defaultLang)}</h2>
                    <Blocks
                      blocks={findTranslation(productCard?._rawTextProductCard, lang, defaultLang)}
                    />
                    <div className={styles.button}>
                      <CTA
                        to={
                          constructSlug({
                            destination: productCard?.ctaProductCard as SanityPageProduct,
                          }) ?? ''
                        }
                        label={findTranslation(
                          pages?.sanityFunctionButton?._rawLearnMore,
                          lang,
                          defaultLang,
                        )}
                        dataType={'productNoBorder'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export const PRODUCTPAGESLUG = graphql`
  query ProductPages {
    sanityFunctionButton {
      _rawLearnMore(resolveReferences: { maxDepth: 10 })
    }
  }
`;
